import React, { useEffect, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { DatePicker } from "antd";
import { ModifiedAntTable } from "./ModifiedAntTable";
import { useQueryParam, NumberParam } from "use-query-params";
import { useParams } from "react-router";
import { useFilterDateDropdown, useListTitle } from "../hooks";
import { getProcurementsAction, procurementDeleteAction } from "../store/org";
import { getIdFieldAndId, getSummationOfFields } from "../utils";

const ProcurementsList = () => {
  const [loading, setLoading] = useState(false);
  const [procurements, setProcurements] = useState([])
  const [refreshTrigger, setRefreshTrigger] = useState(false);
  const [filterDate, setFilterDate] = useState();
  const [filteredProcuremnts, setFilteredProcuremnts] = useState([])
  const [summedData, setSummedData] = useState({});
  const [page, setPage] = useQueryParam("page", NumberParam);

  const { orgType, orgId } = useParams();
  const dispatch = useDispatch();
  const { renderFilter } = useFilterDateDropdown({ setFilterDate });
  const {
    users: { user },
  } = useSelector((state) => ({
    users: state.users,
  }));
  const { org_id_field, org_id } = getIdFieldAndId(orgType, orgId)
  const { fullListName } = useListTitle("procurements")

  useEffect(() => {
    setFilteredProcuremnts(procurements);
  }, [procurements]);

  useEffect(() => {
    setSummedData(
      getSummationOfFields({
        data: filteredProcuremnts,
        fieldsToSum: ["amount"],
      })
    );
  }, [filteredProcuremnts]);

  useEffect(() => {
    let queryString = `${org_id_field}=${org_id}`;

    if (filterDate) {
      queryString = queryString.concat(
        `&start_date=${filterDate[0].format(
          "YYYY/MM/DD"
        )}&end_date=${filterDate[1].format("YYYY/MM/DD")}`
      );
    }

    setLoading(true);
    dispatch(getProcurementsAction(queryString))
      .then((result) => {
        setProcurements(result);
        setLoading(false);
      })
      .catch((err) => setLoading(false));
  }, [filterDate, refreshTrigger]);

  const handleDelete = async (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this procurment from record?."
      )
    ) {
      await dispatch(procurementDeleteAction(id));
      setRefreshTrigger((current) => !current);
    }
  };

  const tableColumn = [
    {
      title: "S/N",
      dataIndex: "id",
      render: (text, record, index) =>
        ((Number(page) || 1) - 1) * 50 + (index + 1),
      summary: "Summation",
    },
    {
      title: "Date",
      dataIndex: "date",
    },
    {
      title: "Asset Name",
      render: (text, record) => (
        <div>{record?.asset_name}</div>
      ),
    },
    {
      title: "Amount (₦)",
      dataIndex: "amount",
      render: (text, record, index) => (
        <div>{Number(record?.amount).toLocaleString()}</div>
      ),
      summary: summedData["amount"],
    },
    {
      title: "Quantity",
      dataIndex: "quantity",
    },
  ];

  if (["DR", "SM", "AM"].includes(user?.position)) {
    tableColumn.push({
      title: "",
      dataIndex: "id",
      render: (text, record) => (
        <span role="button" onClick={() => handleDelete(record?.id)}>
          <i className="fas fa-trash"></i>
        </span>
      ),
      summary: "-",
    });
  }

  return (
    <div>
      <h3 className="page-title mb-4">{fullListName}</h3>

      <Row compact className="mb-3 filter-panel">
        <Col className="d-flex">
          {renderFilter()}
          <DatePicker.RangePicker
            style={{ width: "100%" }}
            onChange={(val) => setFilterDate(val)}
            className="mb-3"
            value={filterDate}
          />
        </Col>
      </Row>

      <ModifiedAntTable
        loading={loading}
        scroll={{ x: "max-content" }}
        columns={tableColumn}
        dataSource={filteredProcuremnts}
        showSummary={true}
        bordered
        pagination={{
          defaultCurrent: page,
          current: page,
          defaultPageSize: 50,
          hideOnSinglePage: true,
          onChange: (current) => setPage(current),
        }}
      />
    </div>
  );
};

export { ProcurementsList };
